import { BasePresenter } from "core/presenter";
import { CategoryRepository } from "core/repository";
import { CategoryConstraint } from "core/constraint";

export default class CategoryFormPresenter extends BasePresenter {
  initialState() {
    return {
      loading: false
    };
  }

  async onSendForm() {
    const { category, mode } = this.props;

    this.viewModel.loading = true;

    const valid = category.validate(CategoryConstraint);

    if (valid) {
      const result = await this.executeAction(category);

      if (result.success) {
        this.sendNotification({
          type: "success",
          content: `Categoria ${
            mode === "create" ? "criada" : "editada"
          } com sucesso!`
        });

        this.props.onClose(true);
      } else {
        this.sendNotification({
          type: "warning",
          content: `Não foi possível ${
            mode === "create" ? "criar" : "editar"
          } essa categoria. Contate o suporte.`
        });
      }
    }

    this.viewModel.loading = false;
  }

  executeAction(category) {
    const { mode } = this.props;
    category.category_uuid =
      category.category_uuid === "none" ? null : category.category_uuid;

    if (mode === "create") {
      return CategoryRepository.create(category);
    } else {
      return CategoryRepository.update(category.uuid, {
        name: category.name,
        category_uuid: category.category_uuid
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/category/list/form/presenter.js